import { ExplainScreen } from '../components/explain';

export function PageHeader({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <header className="page-header mb-6">
      <h1 className="text-[1.875rem] font-medium leading-9 text-[var(--color-text-primary)]">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-[var(--color-text-muted)]">{subtitle}</p>}
    </header>
  );
}

export { ExplainScreen as ExplainActions };
